var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3096_51313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7786 19.7819L15.4764 22.6417C14.4692 22.8184 13.5088 22.1493 13.3312 21.1473L11.5367 11.0225C11.3592 10.0204 12.0317 9.06485 13.0389 8.88816L29.341 6.0283C30.3482 5.85161 31.3087 6.52072 31.4863 7.52276L33.2807 17.6475C33.4584 18.6496 32.7858 19.6052 31.7786 19.7819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3405 6.0283L21.1895 7.45823L23.627 21.2119L31.7781 19.7819C32.7853 19.6052 33.4578 18.6497 33.2802 17.6476L31.4858 7.52281C31.3082 6.52072 30.3477 5.85161 29.3405 6.0283Z",
    fill: "#96969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6609 26H11.4573C10.4346 26 9.60547 25.1751 9.60547 24.1576V14.1295C9.60547 13.112 10.4346 12.2871 11.4573 12.2871H27.6609C28.6837 12.2871 29.5128 13.112 29.5128 14.1295V24.1576C29.5128 25.1751 28.6837 26 27.6609 26Z",
    fill: "#96969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6609 12.2871H19.5591V26H27.6609C28.6836 26 29.5127 25.1751 29.5127 24.1576V14.1295C29.5127 13.112 28.6836 12.2871 27.6609 12.2871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60547 15.4219H29.5128V18.5563H9.60547V15.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1186 22.958H11.9681C11.5846 22.958 11.2737 23.2673 11.2737 23.6489C11.2737 24.0305 11.5846 24.3398 11.9681 24.3398H15.1186C15.5021 24.3398 15.813 24.0305 15.813 23.6489C15.813 23.2673 15.5021 22.958 15.1186 22.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5591 15.4219H29.5127V18.5563H19.5591V15.4219Z",
    fill: "#96969A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3096_51313",
    x: 0.605469,
    y: 0,
    width: 43.7036,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3096_51313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3096_51313",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCards);
export default __webpack_public_path__ + "static/media/credit-cards.07fba882e3687c5d7f5b4b2b900eeddb.svg";
export { ForwardRef as ReactComponent };